<template>
  <div class="market">
    <platform></platform>
    <com-list :data="services" title="我们提供的营销服务" subtitle="为企业提供技术产品的推广、销售线索的获取、技术品牌的打造、开发者生态的共建等"></com-list>
    <com-partner :partners="partners"></com-partner>
  </div>
</template>
<script>
import platform from './platform'
import comList from '../com-list'
import comPartner from '../com-partner'
export default {
  data () {
    return {}
  },
  components: {
    platform,
    comList,
    comPartner
  },
  computed: {
    services () {
      return [{
        img: 'http://static.geekbang.org/infoq/5a227805b1ed5.png?imageView2/0/',
        title: '技术品牌打造',
        word: '由资深技术编辑、社区技术专家量身定做精品技术内容和线下活动，同时提供技术品牌打造、技术专家包装等服务。'
      }, {
        img: 'http://static.geekbang.org/infoq/5a27a537dfb5c.png?imageView2/0/',
        title: '产品 / 技术推广',
        word: '从产品、技术优势、实践案例角度进行包装和策划，以内容、专区、迷你书、线下活动等多种形式推广产品和技术。'
      }, {
        img: 'http://static.geekbang.org/infoq/5a27a536a02cb.png?imageView2/0/',
        title: '商机发现&挖掘',
        word: '通过优质内容的策划、包装聚焦精准人群，采用调查、问卷、线上线下活动等多种形式提供销售商机。'
      }, {
        img: 'http://static.geekbang.org/infoq/5a22780600a7d.png?imageView2/0/',
        title: '企业品牌形象包装',
        word: '通过CEO、CTO高端访谈形式，强化企业品牌影响力和企业技术品牌形象。'
      }, {
        img: 'http://static.geekbang.org/infoq/5a27a535de059.png?imageView2/0/',
        title: '生态建设',
        word: '通过精品内容、开发者大赛、线下活动等形式，协助企业打造由开发者、合作伙伴、ISV、最终用户构成的闭环生态，实现生态共赢。'
      }, {
        img: 'http://static.geekbang.org/infoq/5a2278084706b.png?imageView2/0/',
        title: '新媒体营销解决方案',
        word: '以强大的新媒体矩阵为载体，通过内容报道、专家访谈、社群分享、视频直播、短视频策划制作等形式，提供新媒体营销解决方案。'
      }, {
        img: 'http://static.geekbang.org/infoq/5a227806ee329.png?imageView2/0/',
        title: '企业品牌及业务出海',
        word: '策划、组织国际技术交流活动，搭建国内外企业对话的桥梁，帮助中国企业出海。'
      }, {
        img: 'http://static.geekbang.org/infoq/5a27a53799586.png?imageView2/0/',
        title: '人才招聘',
        word: '通过技术品牌、技术专家的包装树立雇主品牌影响力，通过定制活动实现人才招聘诉求。'
      }, {
        img: 'http://static.geekbang.org/infoq/5a27a536e95df.png?imageView2/0/',
        title: '内容共建',
        word: '邀请合作伙伴，结合我们的报道计划、选题规划，提供符合我们内容定位的文章；或者推荐技术专家为我们供稿、接受访谈、共同策划优质选题。共建精品内容，实现内容共建。'
      }]
    },
    partners () {
      return [{
        link: 'https://amazonaws-china.com/cn/',
        img: 'http://static.geekbang.org/infoq/5a2799bd02751.png?imageView2/0/'
      }, {
        link: 'http://www.alibaba.com/',
        img: 'http://static.geekbang.org/infoq/5a279a29aa322.png?imageView2/0/'
      }, {
        link: 'https://www.baidu.com/',
        img: 'http://static.geekbang.org/infoq/5a279b3428822.png?imageView2/0/'
      }, {
        link: 'https://cloud.tencent.com/?fromSource=gwzcw.186794.186794.186794',
        img: 'http://static.geekbang.org/infoq/5a279b84d84e0.png?imageView2/0/'
      }, {
        link: 'https://www.microsoft.com/zh-cn',
        img: 'http://static.geekbang.org/infoq/5a279bc2dda29.png?imageView2/0/'
      }, {
        link: 'https://www.intel.cn/content/www/cn/zh/homepage.html',
        img: 'http://static.geekbang.org/infoq/5a279bff2b0ab.png?imageView2/0/'
      }, {
        link: 'http://www.huawei.com/cn/?utm_source=bdpz&utm_campaign=regular&utm_medium=cpc',
        img: 'http://static.geekbang.org/infoq/5a2680fe56d9e.png?imageView2/0/'
      }, {
        link: 'https://www.ucloud.cn/',
        img: 'http://static.geekbang.org/infoq/5a279cca5c742.png?imageView2/0/'
      }, {
        link: 'https://www.qiniu.com/',
        img: 'http://static.geekbang.org/infoq/5a279d08b88b7.png?imageView2/0/'
      }, {
        link: 'http://www.tingyun.com/',
        img: 'http://static.geekbang.org/infoq/5a279d35a5ba9.png?imageView2/0/'
      }, {
        link: 'http://www.mogujie.com/',
        img: 'http://static.geekbang.org/infoq/5a279d897885f.png?imageView2/0/'
      }, {
        link: 'https://chaitin.cn/cn/',
        img: 'http://static.geekbang.org/infoq/5a279df319c11.png?imageView2/0/'
      }, {
        link: 'http://www.mininglamp.com/ ',
        img: 'http://static.geekbang.org/infoq/5a279e206f6a5.png?imageView2/0/'
      }, {
        link: 'http://www.talkingdata.com/',
        img: 'http://static.geekbang.org/infoq/5a279ee6a0324.png?imageView2/0/'
      }, {
        link: 'https://dev.mi.com/console/',
        img: 'http://static.geekbang.org/infoq/5a279f681c828.png?imageView2/0/'
      }, {
        link: 'https://www.163yun.com/',
        img: 'http://static.geekbang.org/infoq/5a279f674059e.png?imageView2/0/'
      }, {
        link: 'https://www.ibm.com/us-en/',
        img: 'http://static.geekbang.org/infoq/5a279f67a0b81.png?imageView2/0/'
      }, {
        link: 'https://pivotal.io/cn/',
        img: 'http://static.geekbang.org/infoq/5a27aa817b28c.png?imageView2/0/'
      }, {
        link: 'http://www.creditease.com/?utm_source=sem-baidu',
        img: 'http://static.geekbang.org/infoq/5a279fbb2322d.png?imageView2/0/'
      }, {
        link: 'https://bj.lianjia.com/?utm_source=baidu&utm_medium=pinzhuan&utm_term=biaoti&utm_content=biaotimiaoshu&utm_campaign=sousuo&ljref=pc_sem_baidu_ppzq_x',
        img: 'http://static.geekbang.org/infoq/5a279f670bb96.png?imageView2/0/'
      }]
    }
  }
}
</script>
<style scoped lang='sass'>

</style>
